import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    api(`/contacts`).then(r => r.json()).then(setContacts).catch(() => {});
  }, []);

  const filtered = contacts.filter(c => {
    const companyNames = (c.companies || []).map(co => co.companyName).join(' ');
    const emails = (c.emails || []).map(e => e.email).join(' ');
    return `${c.firstName} ${c.lastName} ${emails} ${companyNames}`.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Contacts</h1>
            <Link to="/crm/contacts/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Add Contact
            </Link>
          </div>
          <input
            type="text"
            placeholder="Search contacts by name, email, or company..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">First Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Last Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Companies</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((c) => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    <Link to={`/crm/contacts/${c.id}`} className="text-blue-600 hover:text-blue-800">{c.firstName}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                    <Link to={`/crm/contacts/${c.id}`} className="text-blue-600 hover:text-blue-800">{c.lastName}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">{c.emails && c.emails.length > 0 ? c.emails[0].email : '—'}</td>
                  <td className="px-6 py-4 text-gray-600 hidden md:table-cell">
                    {c.companies && c.companies.length > 0
                      ? c.companies.map(co => <Link key={co.companyId} to={`/crm/companies/${co.companyId}`} className="text-blue-600 hover:text-blue-800 mr-2">{co.companyName}</Link>)
                      : '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      c.status === 'ACTIVE' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {c.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="text-center py-12 text-gray-500">No contacts found.</div>
          )}
        </div>
      </div>
    </Layout>
  );
}
